<template>
  <div class="flex items-center justify-center grow" v-if="isGetSubscriptionInProgress">
    <AtomSpinner />
  </div>
  <RouterView v-else />
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { onBeforeMount } from 'vue';

import { useSubscriptionStore } from '@/stores';

const subscriptionStore = useSubscriptionStore();

const { subscriptionIdFromStorage, isGetSubscriptionInProgress } = storeToRefs(subscriptionStore);

onBeforeMount(async () => {
  if (subscriptionIdFromStorage.value) {
    await subscriptionStore.fetchSubscription();
  }
});
</script>
